import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function FinancialIcon({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="83"
      viewBox="0 0 82 83"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1667)">
        <path
          d="M72.6025 83V3.76197C72.6025 1.68368 70.9365 0 68.88 0H3.72254C1.66603 0 0 1.68368 0 3.76197V72.8979C0 78.4751 4.47746 82.9737 9.97016 82.9737H72.5765L72.6025 83Z"
          fill="#EAEDF8"
        />
        <path
          d="M10.1006 83.0001C14.9165 83.0001 18.9253 79.3697 19.5501 74.687C19.6542 73.924 20.279 73.3716 21.0339 73.3716H80.4904C81.4276 73.3716 82.1304 74.2134 81.9742 75.1342C81.1412 79.6064 77.2625 83.0001 72.6028 83.0001H10.1006Z"
          fill="#00C4B3"
        />
        <path
          d="M57.7643 26.2547C57.582 26.2547 57.3998 26.2021 57.2176 26.0969C56.697 25.7812 56.5147 25.1235 56.8271 24.5974C56.9573 24.3606 60.1332 18.9413 66.6671 19.8883C67.2659 19.9672 67.6824 20.546 67.6043 21.1248C67.5262 21.7298 66.9535 22.1508 66.3808 22.0718C61.3306 21.3352 58.8316 25.5181 58.7274 25.7023C58.5192 26.0443 58.1547 26.2547 57.7903 26.2547"
          fill="#FAFBFD"
        />
        <path
          d="M38.4224 12.4172C34.7259 12.4172 32.2529 13.1538 31.1335 13.601C30.7431 13.7589 30.3005 13.5747 30.1183 13.1801C27.437 7.65555 22.5691 5.44573 20.5126 4.70912C20.018 4.52496 19.4973 4.86696 19.4453 5.41942C19.185 7.97124 18.7424 14.7586 20.7469 18.0733C20.6948 18.4679 20.6427 18.731 20.5907 19.0993C16.8421 22.3614 14.2129 26.7021 13.3799 31.5953C13.3799 31.5953 11.6878 34.2524 7.26243 34.9364C6.87195 34.989 6.55957 35.331 6.55957 35.7519V44.2229C6.55957 44.6438 6.87195 45.0121 7.31449 45.0384C9.44909 45.2226 15.6186 45.9855 18.2999 48.6689V48.6162C19.4973 50.0105 20.877 51.2733 22.4129 52.3519C22.4129 52.3519 25.0421 58.1132 23.6624 64.0324C23.5323 64.5586 23.9488 65.0321 24.4694 65.0321H32.6694C33.19 65.0321 33.5805 64.5586 33.4764 64.0587C33.2161 62.5329 32.8777 59.4286 34.0751 56.5085C34.0751 56.5085 39.3596 58.5342 44.0713 56.1139C44.9564 59.6917 44.5399 62.5592 44.1754 64.0061C44.0453 64.5323 44.4358 65.0321 44.9824 65.0321H53.1304C53.5729 65.0321 53.9373 64.6638 53.9373 64.2166C54.2237 50.3262 62.0072 48.9582 62.0072 34.989C62.0072 22.7823 52.7399 12.3646 38.5266 12.3646"
          fill="#FAFBFD"
        />
        <path
          d="M25.5894 27.5702C25.5894 29.5433 24.0015 31.1481 22.0491 31.1481C20.0967 31.1481 18.5088 29.5433 18.5088 27.5702C18.5088 25.5972 20.0967 23.9924 22.0491 23.9924C24.0015 23.9924 25.5894 25.5972 25.5894 27.5702Z"
          fill="#00C4B3"
        />
        <path
          d="M26.9688 35.5678C26.9688 42.1183 32.2272 47.4324 38.7091 47.4324C45.191 47.4324 50.4234 42.1183 50.4234 35.5678C50.4234 29.0172 45.1649 23.7031 38.7091 23.7031C32.2532 23.7031 26.9688 29.0172 26.9688 35.5678Z"
          fill="#00416B"
        />
        <path
          d="M43.1869 38.3827L45.7119 39.6454C44.5145 41.75 42.3538 43.0917 39.6465 43.0917C36.2624 43.0917 33.7634 40.9871 32.8523 37.988H30.4053L31.6548 35.9624H32.5659C32.5659 35.8045 32.5659 35.6993 32.5659 35.5678V35.2258H30.4573L31.7069 33.1738H32.9304C33.7894 30.1484 36.3405 27.9912 39.7246 27.9912C42.4319 27.9912 44.5926 29.3592 45.79 31.4375L43.265 32.7265C42.5621 31.5427 41.3386 30.8061 39.7246 30.8061C37.9284 30.8061 36.6008 31.7269 35.924 33.1475H42.8745L41.651 35.1995H35.4554V35.5414C35.4554 35.5414 35.4554 35.8045 35.4554 35.9361H41.4427L40.3234 37.9617H35.95C36.6269 39.356 37.9284 40.2505 39.6986 40.2505C41.3126 40.2505 42.5361 39.5139 43.2389 38.33L43.1869 38.3827Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1667">
          <rect width="82" height="83" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
